import { render, staticRenderFns } from "./LinkForm.vue?vue&type=template&id=683b4c4c&scoped=true"
import script from "./LinkForm.vue?vue&type=script&lang=js"
export * from "./LinkForm.vue?vue&type=script&lang=js"
import style0 from "./LinkForm.vue?vue&type=style&index=0&id=683b4c4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683b4c4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
